import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.293457L12.8103 1.41397L12.8125 1.41699L12.8206 1.42813L12.8541 1.47409C12.8841 1.51495 12.9289 1.57582 12.9873 1.65427C13.1041 1.81119 13.2748 2.03822 13.4888 2.31587C13.9173 2.87179 14.5168 3.6275 15.2015 4.42822C15.8876 5.23058 16.6508 6.06811 17.407 6.79209C18.1742 7.52664 18.8873 8.0984 19.4735 8.41358C19.858 8.62027 20.1969 8.77335 20.476 8.87252C20.7694 8.97681 20.9376 9.00003 21 9.00003H22V11H20.9892C20.6649 10.9984 20.3249 10.925 20 10.8222V11H4V10.8222C3.67507 10.925 3.33506 10.9984 3.0108 11H2V9.00003H3C3.06241 9.00003 3.23056 8.97681 3.52403 8.87252C3.80306 8.77335 4.14202 8.62027 4.52647 8.41358C5.1127 8.09841 5.82578 7.52664 6.593 6.79209C7.34918 6.06811 8.11236 5.23058 8.79848 4.42822C9.48318 3.6275 10.0827 2.87179 10.5112 2.31587C10.7252 2.03822 10.896 1.81119 11.0127 1.65427C11.0711 1.57582 11.1159 1.51495 11.1459 1.47409L11.1794 1.42813L11.1875 1.41699L11.1897 1.41397L12 0.293457Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 13L4 20H2V22H9V19.0005C9 17.3436 10.3431 16.0005 12 16.0005C13.6569 16.0005 15 17.3436 15 19.0005V22H22V20H20V13H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 18C11.4477 18 11 18.4477 11 19V22H13V19C13 18.4477 12.5523 18 12 18Z"}}]};

const AtticFilled = Vue.extend<IconProps>({
  name: 'AtticFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'attic-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AtticFilled;
